export const ManualPaymentModalFieldJSON = {
  "1717412415059-textfield": {
    elementid: 1717412415059,
    elementtype: "textfield",
    "display-fieldlabel": "Transaction Id",
    // "display-required": 1,
    "database-label": "txn_id",
    "display-placeholder": "Enter",
    "validation-maxlength": "200",
    "display-labelposition": "top",
    "display-disabled": 0,
    "display-required": 1,
  },
  "1717412315194-customSelect": {
    elementid: 1717412315194,
    elementtype: "customSelect",
    "display-required": 1,
    "database-label": "mode",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "display-fieldlabel": "Payment Mode",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1717412308306-number": {
    elementid: 1717412308306,
    elementtype: "number",
    "display-fieldlabel": "Payment Amount",
    // "display-required": 1,
    "database-label": "amount",
    "display-placeholder": "Enter",
    "validation-maxlength": "100",
    "validation-minlength": "1",
    "display-labelposition": "top",
    "display-disabled": 0,
    "display-required": 1,
  },
  "1717412405877-customDate": {
    elementid: 1717412405877,
    elementtype: "customDate",
    "display-fieldlabel": "Payment Date",
    // "display-required": 1,
    "database-label": "payment_date",
    "display-placeholder": "Enterr",
    // "validation-maxlength": "100",
    // "validation-minlength": "1",
    "display-labelposition": "top",
    "display-disabled": 0,
    "display-required": 1,
    allowFutureDates: 0,
  },
  "1717412415058-textfield": {
    elementid: 1717412415058,
    elementtype: "textfield",
    "display-fieldlabel": "Order Id",
    // "display-required": 1,
    "database-label": "order_id",
    "display-placeholder": "Enter",
    "validation-maxlength": "200",
    "display-labelposition": "top",
    "display-disabled": 0,
    "display-required": 0,
  },
  "1717412274041-file": {
    elementid: 1717412274041,
    elementtype: "file",
    "display-fieldlabel": "Attachment",
    // "display-required": 1,
    "database-label": "payment_slip_media_id",
    "display-placeholder": "dd-mm-yyyy",
    "display-labelposition": "top",

    // allowFutureDates: 1,
    // "display-disabled": 1,
  },
  "1717412387761-textarea": {
    elementid: 1717412387761,
    elementtype: "textarea",
    "display-fieldlabel": "Note",
    "database-label": "note",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
  },
};
